import { createRequest } from '../helpers/api_utils';
import { FormInput } from '../types/login_register_types';
import { apiUrl } from './api_url';

const apiEndpoint = apiUrl + '/user';
const apiEndpointEmail = apiEndpoint + '/email';

export function loginUser(user: FormInput) {
  const body ={
    email: user.email,
    password: user.password,
  };
  return fetch(createRequest(apiEndpoint + '/token', 'POST', 'application/json', false, body))
    .then(response => {
      return response.json();
    });
}

export function registerUser(user: FormInput) {
  const body = {
    first_name: user.firstname,
    last_name: user.lastname,
    email: user.email,
    password: user.password,
    organization_id: '0',
    profile_type: '0',
  };
  return fetch(createRequest(apiEndpoint + '/register', 'POST', 'application/json', false, body));
}

export function findUser(id: string) {
  return fetch(createRequest(apiEndpoint + `/find?user_id=${id}`, 'GET', 'application/json', false));
}

export function userSearch(name: string) {
  return fetch(createRequest(apiEndpoint + `/search?name=${name}`, 'GET', 'application/json', true))
    .then(response => {
      return response.json();
    });
}

export function isUserVerified(token: string) {
  const body = {
    token: token,
  };
  return fetch(createRequest(apiEndpointEmail + '/verification', 'POST', 'application/json', false, body));
}

export function resendEmail(email: string) {
  const body = {
    email: email,
  };
  return fetch(createRequest(apiEndpointEmail + '/verification/resend', 'POST', 'application/json', false, body));
}

export function changePassword(password: string) {
  const body = {
    password: password,
  };
  return fetch(createRequest(apiUrl + '/password', 'PUT', 'application/json', true, body));
}

export function requestPasswordChange(email: string) {
  const body = {
    email: email,
  };
  return fetch(createRequest(apiUrl + '/password-reset', 'POST', 'application/json', true, body))
    .then(response => {
      if (response.ok) {
        return response.json();
      }
    });
}

export function getUser() {
  return fetch(createRequest(apiEndpoint, 'GET', 'application/json', true));
}

export function createUser(password: string) {
  return fetch(createRequest(apiEndpoint, 'POST', 'application/json', true, { password: password }));
}

export function getCurrentUser() {
  return fetch(createRequest(apiEndpoint + '/me', 'GET', 'application/json', true))
    .then(response => {
      return response.json();
    });
}

export type UserProfileUpdate = {
  firstName: string;
  lastName: string;
  phone?: string;
  bio?: string;
  jobTitleId?: string;
};

// The backend only touches the fields it actually receives, so omit anything
// the caller did not set rather than sending it as an empty value.
export function updateUser(update: UserProfileUpdate) {
  const body: Record<string, string> = {
    first_name: update.firstName,
    last_name: update.lastName,
  };
  if (update.phone !== undefined) body.phone = update.phone;
  if (update.bio !== undefined) body.bio = update.bio;
  if (update.jobTitleId !== undefined) body.job_title_id = update.jobTitleId;

  return fetch(createRequest(apiEndpoint + '/update', 'PUT', 'application/json', true, body))
    .then(response => {
      return response.json();
    });
}

export function deleteCurrentUser() {
  return fetch(createRequest(apiEndpoint + '/delete', 'PUT', 'application/json', true));
}

export function updateProfilePic(fileName: string) {
  const body = {
    file_name: fileName,
  };
  return fetch(createRequest(apiEndpoint + '/profile-pic', 'POST', 'application/json', true, body))
    .then(response => {
      return response.json();
    });
}

export function addUsersToAssessmentWithFile(csvFile: File, assessmentId: string) {
  let formData = new FormData();
  formData.append('file', csvFile);
  formData.append('assessment_id', assessmentId);

  const requestOptions = {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    },
    body: formData,
  };

  return fetch(apiEndpoint + '/add/csv', requestOptions);
}

export function updateStatus(status: string) {
  const params = new URLSearchParams({
    status: status,
  });
  const url = `${apiEndpoint}/job-seeking-status?${params}`;
  return fetch(createRequest(url, 'PUT', 'application/json', true));
}

export function getDashboardDetails() {
  return fetch(createRequest(apiEndpoint + '/profile/dashboard', 'GET', 'application/json', true));
}

export function getApplicationsDetails(search: string, page: number, limit: number) {

  const queryParams = new URLSearchParams({
    search: search,
    page: page.toString(),
    limit: limit.toString(),
  });

  return fetch(createRequest(apiEndpoint + `/profile/applications?${queryParams.toString()}`, 'GET', 'application/json', true));
}

export function getAssessmentsDetails(search: string, page: number, limit: number) {

  const queryParams = new URLSearchParams({
    search: search,
    page: page.toString(),
    limit: limit.toString(),
  });

  return fetch(createRequest(apiEndpoint + `/profile/assessments?${queryParams.toString()}`, 'GET', 'application/json', true));
}

export function getInterviewsDetails(search: string, page: number, limit: number) {

  const queryParams = new URLSearchParams({
    search: search,
    page: page.toString(),
    limit: limit.toString(),
  });

  return fetch(createRequest(apiEndpoint + `/profile/interviews?${queryParams.toString()}`, 'GET', 'application/json', true));
}
